import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'boolean' })
export class BooleanPipe implements PipeTransform {
  transform(
    value: boolean | number | string | undefined,
    textForUndefined: string | undefined = undefined
  ): string | undefined {
    if (textForUndefined && value === undefined) {
      return textForUndefined;
    }
    return value ? 'Ja' : 'Nej';
  }
}
